export const deleteClassAction = (id) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(application);
      firestore
        .collection('classes')
        .doc(id)
        .delete()
        .then(() => {
          dispatch({
            type: "DELETE_CLASS",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "DELETE_CLASS_ERR",
            err
          });
        });
    };
  };
  